import { getFieldSurfaceStyles } from '../design-system';

export const searchFieldStyles = {
  width: 220,
  ...getFieldSurfaceStyles('sunken'),
  '& .MuiInputBase-root': {
    height: 38,
    borderRadius: 2,
  },
};
